import { User } from "../../types/user";
import { generateAPI } from "../api.generator";

export const getUserByToken = generateAPI<{}, User>("get", "user");
